import * as z from "zod/v4";

export const hasMultipleOrders = {
  name: "hasMultipleOrders" as const,
  input: z.object({}).optional(),
  output: z.object({
    hasMultipleOrders: z.boolean(),
    isGiftReceiptLogin: z.boolean(),
  }),
};
